import styled from "styled-components";

export const Magic8BallOverlayCloseDefaultBox = styled.div`
    user-select: none;
    position: absolute;
    top: 1rem;
    right: 1rem;
    cursor: pointer;
`;